module.exports = __webpack_public_path__ + "static/media/image-1.0a3485da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Weather/image-1.png
// module id = 291
// module chunks = 0